import { pdkAxios } from '@/lib/pdk-axios';
import type { Deal } from '@/models/registry';
import { useMutation, useQueryClient } from '@tanstack/react-query';

const useKickoffContinueFlowMutation = ({
  dealId,
  shortId,
  onSuccess,
  onError,
}: {
  dealId: Deal['id'] | null | undefined;
  shortId: Deal['short_id'] | null | undefined;
  onSuccess?: (data: any) => void;
  onError?: (error: Error) => void;
}) => {
  const queryClient = useQueryClient();

  const kickoffConfirmFlowMutation = useMutation({
    mutationFn: async () => {
      if (!dealId) {
        throw new Error('Deal ID is required');
      }

      const response = await pdkAxios
        .post(`/deals/${dealId}/kickoff-continue-flow`)
        .catch((e) => {
          console.error('Error kicking off/continue flow', e);
          throw e;
        });

      return response.data;
    },
    onSuccess: (data) => {
      onSuccess?.(data);
    },
    onError: (error) => {
      onError?.(error);
      console.error('Error kicking off/continue flow', error);
    },
    onSettled: () => {
      queryClient.invalidateQueries({ queryKey: ['deal', shortId] });
    },
  });

  return { kickoffConfirmFlowMutation };
};

export default useKickoffContinueFlowMutation;
